/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface PaymentLinkDTO {
  id?: string;
  establishmentId?: number;
  establishmentName?: string;
  value?: number;
  customerEmail: string;
  orderNumber?: string;
  observations?: string;
  paid?: boolean;
  paidToEstablishment?: boolean | null;
  customerName?: string;
  date?: string | null;
  link?: string;
  expired?: boolean;
  canceled?: boolean;
  callbackUrl?: string | null;
  currencyCode?: string;
  customerPhoneNumber?: string | null;
  qrcodeUrl?: string | null;
  returnUrl?: string | null;
  formHeaderHtml?: string | null;
  formFooterHtml?: string | null;
  linkType?: number;
  establishmentSupportsFinancingCosts?: boolean | null;
  pdfUrl?: string;
}
